// extracted by mini-css-extract-plugin
export default {"Container":"App_Container__qCgUR"};